export const isDesktopView = (screenWidth, minWidth = 1024) =>
  screenWidth >= minWidth;

export const isTabletView = (screenWidth, maxWidth = 1024, minWidth = 640) =>
  screenWidth < maxWidth && screenWidth >= minWidth;

export const isMobileView = (screenWidth, maxWidth = 640) =>
  screenWidth < maxWidth;
